module.exports = __webpack_public_path__ + "clients-slide3.2Gyt2IgZ.svg";